import { Component, effect, inject, input } from '@angular/core';
import { UIService } from '@core/services';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
  imports: [NgxSpinnerModule],
  selector: 'app-spinner',
  template: `
    @if (name(); as spinnerName) {
      <ngx-spinner
        [name]="spinnerName"
        bdColor="rgba(0, 0, 0, 0)"
        size="medium"
        type="ball-spin-clockwise-fade"
        color="rgba(0, 0, 0, 0.4)"
        [fullScreen]="fullScreen()"
      ></ngx-spinner>
    } @else {
      <ngx-spinner
        bdColor="rgba(0, 0, 0, 0)"
        size="medium"
        type="ball-spin-clockwise-fade"
        color="rgba(0, 0, 0, 0.4)"
        [fullScreen]="fullScreen()"
      ></ngx-spinner>
    }
  `,
})
export class SpinnerComponent {
  readonly fullScreen = input.required<boolean>();
  readonly name = input<string>();
  readonly inProgress = input<boolean | null>(null);

  private readonly spinner = inject(NgxSpinnerService);
  private readonly ui = inject(UIService);

  constructor() {
    effect(() => {
      const inProgress = this.inProgress() ?? this.ui.inProgress();
      const name = this.name();

      if (inProgress) {
        this.show(name);
      } else {
        this.hide(name);
      }
    });
  }

  private show(name?: string): void {
    if (name) {
      void this.spinner.show(name);
      return;
    }

    void this.spinner.show();
  }

  private hide(name?: string): void {
    if (name) {
      void this.spinner.hide(name);
      return;
    }

    void this.spinner.hide();
  }
}
